// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-content-title {
  color: var(--planeed-black);
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 27px;
}

.text-content {
  color: var(--planeed-black);
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  line-height: 21px;
}

.text-content-bold {
  color: var(--planeed-black);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 21px;
}

.text-content-bold-blue {
  color: var(--planeed-blue);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 21px;
}

.content-link {
  color: var(--planeed-blue);
  text-decoration: none;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 21px;
  margin-left: 5px;
}

.content-link:hover {
  text-decoration: underline;
}

.text-small-gray {
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.24px;
  color: var(--planeed-gray);
}

#mapEl {
  height: 100vh;
  width: 100%;
}

.map-container {
  position: relative;
  height: 100%;
  width: 100%;
}

.map-canvas {
  height: 100%;
  width: 100%;
  transform: none !important;
}

.mapboxgl-ctrl-bottom-right {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 2rem;
}

.mapboxgl-ctrl-group button:first-child {
  padding: 10px !important;
  height: 40px !important;
  width: 40px !important;
}

.mapboxgl-ctrl-group button:last-child {
  padding: 10px !important;
  height: 40px !important;
  width: 40px !important;
}

.mapboxgl-ctrl-group button + button {
  padding: 10px !important;
  height: 40px !important;
  width: 40px !important;
}

.mapboxgl-ctrl button:not(:disabled):hover {
  background-color: white !important;
}

.mapboxgl-marker {
  overflow: visible;
}

.side-panel {
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 30vw;
  max-width: 680px;
  display: flex;
  flex-direction: column;
  background: var(--planeed-color-white);
  box-shadow: -4px 0 10px 0 rgba(0, 0, 0, 0.15);
  z-index: 20;
  opacity: 0;
  pointer-events: none;
  transform: translateX(100%);
  transition: transform 240ms ease, opacity 240ms ease;
  will-change: transform;
}

.map-container.panel-open .side-panel {
  transform: translateX(0);
  opacity: 1;
  pointer-events: auto;
}

.panel-header {
  display: flex;
  align-items: center;
  padding: 20px;
}

.side-panel-back {
  font-size: 20px;
  cursor: pointer;
}

.mapboxgl-popup-content {
  background-color: var(--planeed-color-white);
  border-radius: 10px !important;
  margin-bottom: 25px;
  box-shadow: 0 4px 8px 1px rgba(1, 33, 36, 0.5);
  padding: 5px !important;
  height: 100% !important;
  width: 100%;
}

.map-hover-popup-moment {
  padding-top: 5px;
  padding-left: 5px;
  padding-right: 5px;
  height: 100%;
  width: 100%;
  border-radius: 10px;
}

.mapboxgl-popup-tip {
  display: none;
}

.mapboxgl-popup {
  width: 100% !important;
}

.map-hover-popup-moment-img {
  border-radius: 10px;
}

.mr-5 {
  margin-right: 5px;
}

.ml-5 {
  margin-left: 5px;
}

.content-link-container {
  display: flex;
  align-items: center;
  margin: 12px 0;
}

ion-modal::part(handle) {
  width: 60px;
  height: 3px;
  margin-top: 1rem;
  background-color: var(--ion-color-secondary);
}

.marker-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.marker {
  cursor: pointer;
  border-radius: 8px;
}

/* --- Moment --- */
.marker-moment {
  background-color: #fff;
  background-size: cover;
  background-position: center;
  width: 40px;
  height: 50px;
  box-shadow: 0 4px 8px 1px rgba(1, 33, 36, 0.5);
}

/* --- Organization --- */
.marker-organization {
  background-color: #fff;
  background-size: cover;
  background-position: center;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  box-shadow: 0 4px 8px 1px rgba(1, 33, 36, 0.5);
}

/* --- Space --- */
.marker-space {
  background-color: #fff;
  background-size: cover;
  background-position: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  box-shadow: 0 4px 8px 1px rgba(1, 33, 36, 0.5);
}

/* --- Default --- */
.marker-poa {
  background-size: contain;
  background-position: center;
  background-color: transparent;
  width: 40px;
  height: 40px;
  border-radius: 0;
}

/* Label */
.marker-label {
  margin-top: 4px;
  font-size: 16px;
  font-weight: 500;
  color: var(--planeed-blue);
  line-height: 18px;
  text-shadow: -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
  transition: opacity 0.2s ease;
  opacity: 0;
  pointer-events: none;
}

.marker-wrapper:hover .marker-label {
  opacity: 1;
}

.marker-wrapper.selected .marker-label {
  opacity: 1;
}

.bottom-btns {
  display: flex;
  flex-direction: row;
  width: 100%;
  position: absolute;
  bottom: 0;
  z-index: 99;
  height: calc(65px + var(--ion-safe-area-bottom));
  background-color: var(--planeed-color-white);
  padding-bottom: var(--ion-safe-area-bottom);
}
.bottom-btns .btn-container {
  padding: 5px 10px;
  width: 50%;
}
.bottom-btns .btn-container ion-button {
  width: 100%;
}
.bottom-btns .ok-btn-container {
  padding: 5px 10px;
  width: 100%;
}
.bottom-btns .ok-btn-container ion-button {
  width: 100%;
}

.deselect-location {
  display: flex;
  flex-direction: row;
  align-items: center;
  position: absolute;
  height: 34px;
  width: fit-content;
  max-width: 80%;
  padding: 0 15px;
  border-radius: 17px;
  background-color: var(--planeed-color-white);
  left: 15px;
  z-index: 99;
  border: 2px solid var(--ion-color-danger);
  cursor: pointer;
  color: #0f0f0f;
}
.deselect-location ion-icon {
  margin-right: 10px;
}

.deselect-location-top {
  bottom: calc(134px + var(--ion-safe-area-bottom));
}

.deselect-location-bottom {
  bottom: calc(80px + var(--ion-safe-area-bottom));
}

.show-on-map {
  display: flex;
  flex-direction: row;
  align-items: center;
  position: absolute;
  height: 34px;
  width: fit-content;
  max-width: 80%;
  padding: 0 15px;
  border-radius: 17px;
  background-color: var(--ion-color-secondary);
  color: var(--planeed-color-white);
  bottom: calc(80px + var(--ion-safe-area-bottom));
  left: 15px;
  z-index: 99;
  cursor: pointer;
}
.show-on-map ion-icon {
  margin-right: 10px;
  font-size: 14px;
  fill: #ffffff;
}

.fly-to-position {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 15px;
  border-radius: 10px;
  bottom: calc(80px + var(--ion-safe-area-bottom));
  z-index: 99;
  cursor: pointer;
  width: 34px;
  height: 34px;
  background-color: var(--planeed-color-white);
  font-size: 20px;
}
.fly-to-position ion-icon {
  fill: var(--planeed-blue);
}
.fly-to-position ion-icon:hover {
  fill: var(--ion-color-warning);
}

.map-search {
  z-index: 99;
}

.search-icon-container {
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.3);
  position: absolute;
  z-index: 99;
  top: 12px;
  right: 12px;
  height: 40px;
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 10px;
  background-color: var(--planeed-color-white);
  transition: background-color 0.3s ease, transform 0.2s ease;
}
.search-icon-container ion-icon {
  font-size: 20px;
}

@media only screen and (max-width: 460px) {
  .search-icon-container {
    top: 110px;
  }
}
.search-icon-container:active {
  transform: scale(0.9);
}

.search-icon-container.active {
  background-color: var(--planeed-blue);
}
.search-icon-container.active ion-icon {
  font-size: 20px;
}

.searchbar {
  position: absolute;
  z-index: 99;
  top: 4px;
  right: 62px;
  opacity: 1;
  transform: translateX(20px);
  transition: opacity 0.3s ease, transform 0.3s ease;
}

@media only screen and (max-width: 460px) {
  .searchbar {
    top: 15px;
  }
}
ion-searchbar.custom-map-search {
  --background: var(--planeed-color-white);
  --border-radius: 20px;
  --clear-button-color: var(--planeed-red);
  --color: var(--planeed-blue);
  --placeholder-color: var(--planeed-gray);
  --placeholder-font-weight: 400;
  --placeholder-opacity: 1;
  width: 300px;
  transform: scaleY(1.1);
}
ion-searchbar.custom-map-search::part(container) {
  height: 40px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.3);
}
ion-searchbar.custom-map-search::part(input) {
  height: 40px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.3);
}

.searchbar-ios .searchbar-clear-icon {
  background-image: url("/src/assets/icon/impact_map/search-icon.svg");
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
